import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Pos from '@/views/Pos'
import Redirect from '@/components/Redirect'
import Lemma from '@/views/Lemma'
import LemmaDif from '@/views/LemmaDif'
import Term from '@/views/Term'
import Ne from '@/views/Ne'
import SentStat from '@/views/SentStat'
import Verbs from '@/views/Verbs'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Redirect',
      component: Redirect,
      props: false
    },
    // {
    //   path: '*',
    //   name: 'Redirect',
    //   component: Redirect,
    //   props: false
    // },
    {
      path: '/:taskId',
      name: 'Home',
      component: Home,
      props: true
    },
    {
      path: '/pos/:taskId',
      name: 'Pos',
      component: Pos,
      props: true
    },
    {
      path: '/lemma/:taskId',
      name: 'Lemma',
      component: Lemma,
      props: true
    },
    {
      path: '/lemma_dif/:taskId',
      name: 'LemmaDif',
      component: LemmaDif,
      props: true
    },
    {
      path: '/ne/:taskId',
      name: 'Ne',
      component: Ne,
      props: true
    },
    {
      path: '/term/:taskId',
      name: 'Term',
      component: Term,
      props: true
    },
    {
      path: '/verbs/:taskId',
      name: 'Verbs',
      component: Verbs,
      props: true
    },
    {
      path: '/sentstat/:taskId',
      name: 'SentStat',
      component: SentStat,
      props: true
    },
    {
      path: '/nkjp_pl',
      beforeEnter () { location.href = 'http://github.com' }
    }
    // {
    //   name: 'Yyy',
    //   redirect: 'http://ws-test.clarin-pl.eu'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js